import { useQuery } from '@tanstack/react-query';

import { checkCustomerHistory } from '@/services/customer-history';

export default function useCustomerHistory({
  userId,
  email,
  phone,
  countryCode,
}: {
  userId?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
} = {}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['customerHistory', userId, email, phone, countryCode],
    queryFn: () =>
      checkCustomerHistory({
        user_id: userId,
        email,
        phone,
        country_code: countryCode,
      }),
    enabled: !!userId || !!email || !!phone,
  });

  return {
    isNewCustomer: data ?? true,
    isLoading,
    error,
  };
}
